'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var loadProductRecommendationsIntoSection = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(el, container) {
    var _el$dataset, limit, productId, sectionId, request, response, swiperContainer, makeCarousel;

    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            makeCarousel = function makeCarousel() {
              (0, _helpers.initialiseSwiper)(swiperContainer, {
                loop: true,
                watchSlidesProgress: true,
                slidesPerView: 1.6,
                centeredSlides: true,
                initialSlide: 1,
                spaceBetween: 0,
                speed: 500,
                slideClass: 'js-ProductCarousel_Slide',
                breakpoints: {
                  768: {
                    slidesPerView: 2.4
                  },
                  960: {
                    slidesPerView: 4.3
                  }
                },
                navigation: {
                  nextEl: '.js-ProductCarousel_Next',
                  prevEl: '.js-ProductCarousel_Prev'
                }
              }, [_swiper.Navigation]);
            };

            if (!(el == null || container == null)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt('return');

          case 3:
            _el$dataset = el.dataset, limit = _el$dataset.limit, productId = _el$dataset.productId, sectionId = _el$dataset.sectionId;
            request = fetch('/recommendations/products?section_id=' + sectionId + '&limit=' + limit + '&product_id=' + productId, (0, _assign2.default)({}, (0, _functional.getDefaultRequestConfig)(), {
              method: 'GET'
            })).then(function (res) {
              return res.text();
            });
            _context2.next = 7;
            return request;

          case 7:
            response = _context2.sent;

            el.outerHTML = response;

            swiperContainer = (0, _functional.getElement)('.js-ProductCarousel_Carousel');

            makeCarousel();

          case 11:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function loadProductRecommendationsIntoSection(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _themeSections = require('@shopify/theme-sections');

var _swiper = require('swiper/js/swiper.esm');

var _helpers = require('../modules/_helpers');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

(0, _themeSections.register)('recommended-products', {
  onLoad: function onLoad(event) {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var el, container;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              el = (0, _functional.getElement)('.js-RecommendedProducts');

              if (!(el == null)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              container = (0, _functional.getElement)('.js-RecommendedProducts_Container', {
                context: el
              });
              _context.next = 6;
              return loadProductRecommendationsIntoSection(el, container);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});